import API from "@utils/plugins/API";

const SubStrataService = {
  all: (params) => {
    return API.get("sub-strata", { params: params });
  },
  create: (name, name_eng, stratum_id, description) => {
    return API.post("sub-strata", {
      name,
      name_eng,
      stratum_id,
      description,
    });
  },
  update: (id, name, name_eng, stratum_id, description) => {
    return API.put(`sub-strata/${id}`, {
      name,
      name_eng,
      stratum_id,
      description,
    });
  },
  find: (id) => {
    return API.get(`sub-strata/${id}`);
  },
  destroy: (id) => {
    return API.delete(`sub-strata/${id}`);
  },
};

export default SubStrataService;
